import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { FormControl, Icon, FormSelectOutsideTag } from 'components/ui';

export default function Others({ languages, languagesTags }) {
  const { t } = useTranslation();

  return (
    <Accordion
      title={t('Other info')}
      startAdornment={
        <div>
          <Icon icon="info-square" />
        </div>
      }
    >
      <FormControl label={t('Preferred languages')}>
        <FormSelectOutsideTag
          name="preferredLanguages"
          dataId="select-tags"
          options={languages}
          defaultValue={languagesTags || []}
          value={languagesTags || []}
          placeholder={t('Preferred languages')}
          boxStyle={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            flexWrap: 'wrap',
            maxWidth: 600,
          }}
          inputStyle={{ width: 250, marginRight: 20 }}
        />
      </FormControl>
    </Accordion>
  );
}
